export default "__VITE_ASSET__bcf87347__"